<div class="w-full space-y-6 animate-fade-in">
  <!-- Welcome Text -->
  <div class="text-center md:text-left">
    <h2 class="text-2xl font-bold text-greyscale-900 mb-2">
      {{ 'emailVerification.checkEmail' | transloco }}
    </h2>
  </div>

  <!-- Content -->
  <div class="w-full space-y-4">
    <p class="text-center md:text-left text-paragraph-reg text-greyscale-600">
      {{ 'emailVerification.verificationLinkSent' | transloco }}<br>
      <strong class="text-greyscale-900">{{ email() }}</strong>
    </p>

    <!-- Instructions -->
    <div class="rounded-md bg-greyscale-50 p-4">
      <div class="space-y-3 text-paragraph-reg text-greyscale-700">
        <p class="flex items-center">
          <i class="pi pi-check mr-3 text-primary-500"></i>
          {{ 'emailVerification.clickLink' | transloco }}
        </p>
        <p class="flex items-center">
          <i class="pi pi-clock mr-3 text-primary-500"></i>
          {{ 'emailVerification.linkExpires' | transloco }}
        </p>
        <p class="flex items-center">
          <i class="pi pi-inbox mr-3 text-primary-500"></i>
          {{ 'emailVerification.checkSpam' | transloco }}
        </p>
      </div>
    </div>

    <!-- Success/Error messages -->
    @if (message()) {
      <div class="rounded-md p-3" 
           [ngClass]="messageType() === 'success' ? 'bg-validation-50 text-validation-800 border border-validation-200' : 'bg-error-50 text-error-800 border border-error-200'">
        <p class="text-paragraph-s-reg">{{ message() }}</p>
      </div>
    }

    <!-- Resend button -->
    <button
      type="button"
      (click)="resendVerification()"
      [disabled]="isResending() || cooldownSeconds() > 0"
      class="flex w-full justify-center rounded-md border border-transparent bg-primary-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
    >
      @if (isResending()) {
        <i class="pi pi-spin pi-spinner mr-2"></i>
        {{ 'emailVerification.sending' | transloco }}
      } @else if (cooldownSeconds() > 0) {
        {{ 'emailVerification.resendIn' | transloco }} {{ cooldownSeconds() }}s
      } @else {
        <i class="pi pi-send mr-2"></i>
        {{ 'emailVerification.resendEmail' | transloco }}
      }
    </button>
  </div>

  <!-- Links -->
  <div class="flex flex-col items-center md:items-start gap-2">
    <a
      class="text-sm font-medium text-primary-600 no-underline hover:text-primary-500 flex items-center"
      routerLink="/auth/login"
    >
      <i class="pi pi-arrow-left mr-2"></i>
      {{ 'emailVerification.backToLogin' | transloco }}
    </a>
  </div>

  <p-toast />
</div>